import React from 'react'
import { Grid } from "@mui/material"
import { AppFormSection } from "@components"
import SelectorWithSkeleton from "Pages/Admin/Users/CreateDrawer/Content/SelectorSkeleton"
import UserSitesField from "Pages/Admin/Users/CreateDrawer/Content/SitesOffices/Sites"
import UserOfficesField from "Pages/Admin/Users/CreateDrawer/Content/SitesOffices/Offices"
import UserNewOfficeSubSection from "Pages/Admin/Users/CreateDrawer/Content/SitesOffices/NewOffice"


export default function UserSitesOfficesContent({ isLoading }) {


	return <AppFormSection icon="city" title="Sites & Offices">
		<Grid container spacing={2}>
			<SelectorWithSkeleton SelectorComponent={UserSitesField} isLoading={isLoading} xs={6}/>
			<SelectorWithSkeleton SelectorComponent={UserOfficesField} isLoading={isLoading} xs={6}/>
			<Grid item xs={11}>
				<UserNewOfficeSubSection/>
			</Grid>
		</Grid>
	</AppFormSection>
}
